// @flow
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
// material.ui reafctoring
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import IconImage from 'material-ui/svg-icons/image/image';
import IconVideo from 'material-ui/svg-icons/av/videocam';
// draft-js
import { convertToRaw } from 'draft-js';
import mediumDraftExporter from 'medium-draft/lib/exporter';
import 'medium-draft/lib/index.css';
// mutation
import * as PersonAddMutation from '../mutations/PersonAddMutation';
import * as PersonEditMutation from '../mutations/PersonEditMutation';
// editor
import EmbedSideButton from './editor/EmbedSideButton';
import insertMediaItem from './editor/insertMediaItem';
// add media
import PopupGallery from './media/PopupGallery';
import { staticUrl } from '../lib/config';
import { colors } from '../lib/styles';

import DraftEditor from './editor/draft/DraftEditor';

const buttonStyle = {
    marginTop: 40,
    height: 36,
    width: 236,
};

const sidebarStyle = {
    padding: 16,
    width: 326,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};

const personTypes = [
    { id: 'host', text: 'Ведущий' },
    { id: 'author', text: 'Автор' },
    { id: 'person', text: 'Персоналия' },
];

type Props = {
    history: Object,
    match: Object,
    relay: Object,
    viewer: Object,
};

type State = {
    birthdayAt: ?Date,
    changeAvatar: boolean,
    changePhoto: boolean,
    editorState: ?Function,
    firstName: ?string,
    lastName: ?string,
    mediaGalleryType: Array<string>,
    openMediaGallery: boolean,
    personType: string,
    smallAvatar: ?string,
    verticalImage: ?string,
};

class Person extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        const { person } = this.props.viewer;
        const es = person === null ? null : JSON.parse(person.description);
        const isPersonState = person !== null;

        this.state = {
            mediaGalleryType: ['image'],
            openMediaGallery: false,
            changeAvatar: false,
            changePhoto: false,
            personType: isPersonState ? person.personType : this.props.match.params.personType,
            firstName: isPersonState ? person.firstName : '',
            lastName: isPersonState ? person.lastName : '',
            birthdayAt: (isPersonState && person.birthdayAt !== null) ?
                new Date(person.birthdayAt) :
                null,
            smallAvatar: isPersonState ? person.smallAvatar : '',
            verticalImage: isPersonState ? person.verticalImage : '',
            editorState: es !== null ? es : null, // for empty content
        };

        this.sideButtons = [
            {
                title: 'Медиа-галерея видео',
                component: this.galleryBtnVideo,
            },
            {
                title: 'Медиа-галерея изображения',
                component: this.galleryBtnImage,
            }, {
                title: 'Эмбед',
                component: EmbedSideButton,
            },
        ];
    }

    componentDidMount = () => {
        // this.refs.editor.focus();
    };

    onChange = editorState => this.setState({ editorState });

    onPersonTypeChanged = (newValue: string) => this.setState({ personType: newValue });
    onBirthdayChanged = (date: any) => this.setState({ birthdayAt: date });
    onFirstNameChange = (newValue: string) => this.setState({ firstName: newValue });
    onLastNameChange = (newValue: string) => this.setState({ lastName: newValue });
    sideButtons: any;

    galleryBtnImage = () => (
        <button
            className="medium-draft--btn"
            type="button"
            onClick={() => {
                this.setState({
                    mediaGalleryType: ['image'],
                    openMediaGallery: true,
                });
            }}
            title="Add an Image"
        >
            <IconImage color={colors.iconColor} hoverColor={colors.iconHover} />
        </button>
    );

    galleryBtnVideo = () => (
        <button
            className="medium-draft--btn"
            type="button"
            onClick={() => {
                this.setState({
                    mediaGalleryType: ['video'],
                    openMediaGallery: true,
                });
            }}
            title="Add an Video"
        >
            <IconVideo color={colors.iconColor} hoverColor={colors.iconHover} />
        </button>
    );

    insertMediaFile = (item) => {
        const fileData = item;
        fileData.type = fileData.type || fileData.fileType;
        if (this.state.changeAvatar) {
            this.setState({
                changeAvatar: false,
                smallAvatar: fileData.filename,
            });
            return;
        }
        if (this.state.changePhoto) {
            this.setState({
                changePhoto: false,
                verticalImage: fileData.filename,
            });
            return;
        }
        this.setState({ editorState: insertMediaItem(item, this.state.editorState) });
    };

    handleCloseGallery = () => {
        this.setState({
            openMediaGallery: false,
            changeAvatar: false,
        });
    };

    save = () => {
        const callback = (error: ?Error, personId: ?string) => {
            if (error != null) {
                alert('error saving person');
                return;
            }
            if (personId) {
                this.props.history.replace(`/person/${personId}`);
            }
        };

        const baseParams = {
            personType: this.state.personType,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            birthdayAt: this.state.birthdayAt,
            smallAvatar: this.state.smallAvatar,
            verticalImage: this.state.verticalImage,
            description: JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent())),
            descriptionHtml: mediumDraftExporter(this.state.editorState.getCurrentContent()),
        };

        if (baseParams.firstName === '' || baseParams.lastName === '') {
            return;
        }

        const { person } = this.props.viewer;
        if (person) {
            const params = {
                id: person.id,
                ...baseParams,
            };
            PersonEditMutation.commit(this.props.relay.environment, params, callback);
        } else {
            PersonAddMutation.commit(this.props.relay.environment, baseParams, callback);
        }
    };

    render() {
        const { editorState } = this.state;
        return (
            <div style={{ display: 'flex' }}>
                <PopupGallery
                    open={this.state.openMediaGallery}
                    type={this.state.mediaGalleryType}
                    closeDialogHandle={() => {
                        this.setState({ openMediaGallery: false });
                    }}
                    insertMediaFile={(item) => {
                        this.insertMediaFile(item);
                        setTimeout(() => {
                            this.handleCloseGallery();
                        }, 250);
                    }}
                    orientation="vertical"
                    orientationShow
                    insertAfterUpload
                />
                <Paper style={{ width: '100%', padding: 16 }}>
                    <TextField
                        hintText="Имя"
                        floatingLabelText="Имя"
                        value={this.state.firstName}
                        fullWidth
                        errorText={(this.state.firstName === '') ? 'это поле нужно заполнить' : null}
                        onChange={(event, value) => {
                            this.onFirstNameChange(value);
                        }}
                        floatingLabelFixed
                    />

                    <TextField
                        hintText="Фамилия"
                        floatingLabelText="Фамилия"
                        value={this.state.lastName}
                        fullWidth
                        errorText={(this.state.lastName === '') ? 'это поле нужно заполнить' : null}
                        onChange={(event, value) => {
                            this.onLastNameChange(value);
                        }}
                        floatingLabelFixed
                    />

                    {this.state.smallAvatar && <Avatar src={`${staticUrl}/${this.state.smallAvatar}`} />}
                    <br />
                    <RaisedButton
                        containerElement="label"
                        label="Добавить аватар"
                        style={{ margin: '16px 0' }}
                        onClick={() => {
                            this.setState({
                                changeAvatar: true,
                                openMediaGallery: true,
                                mediaGalleryType: ['image'],
                            });
                        }}
                    />
                    <Divider />

                    {this.state.verticalImage &&
                    <img
                        src={`${staticUrl}/${this.state.verticalImage}`}
                        style={{ display: 'block' }}
                        alt={`${this.state.firstName} ${this.state.lastName}`}
                    />
                    }
                    <RaisedButton
                        containerElement="label"
                        label="Добавить фотографию"
                        style={{ margin: '16px 0' }}
                        onClick={() => {
                            this.setState({
                                changePhoto: true,
                                openMediaGallery: true,
                                mediaGalleryType: ['image'],
                            });
                        }}
                    />

                    <Divider />

                    <DraftEditor
						location={null}
                        onChange={editorState => this.setState({ editorState })}
                        state={editorState}
                    />

                    <Divider />

                </Paper>
                <div style={sidebarStyle}>
                    <DatePicker
                        autoOk
                        floatingLabelText="День рождения"
                        onChange={(event, value) => {
                            this.onBirthdayChanged(value);
                        }}
                        value={this.state.birthdayAt}
                    />

                    <SelectField
                        floatingLabelText="Тип"
                        value={this.state.personType}
                        onChange={(event, index, value) => {
                            this.onPersonTypeChanged(value);
                        }}
                    >
                        {
                            personTypes.map(personType => (
                                <MenuItem
                                    key={personType.id}
                                    value={personType.id}
                                    primaryText={personType.text}
                                />
                            ))
                        }
                    </SelectField>

                    <RaisedButton
                        label="Сохранить"
                        style={buttonStyle}
                        primary
                        onClick={() => { this.save(); }}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(createFragmentContainer(
    Person,
    graphql`
        fragment Person_viewer on Viewer @argumentDefinitions(id:{type:"ID!",}) {
            id,
            person(id: $id) {
                id,
                personType,
                description,
                descriptionHtml,
                firstName,
                lastName,
                createdAt,
                updatedAt,
                verticalImage,
                smallAvatar,
                birthdayAt
            },
        }`,
));



// WEBPACK FOOTER //
// src/components/Person.js